import React from "react";
import Insta from "./logo/instaa.png";
import twitch from "./logo/twitch.png";
import naver from "./logo/naver.png";
import ytb_2 from "./logo/ytb3.png";
import tt from "./logo/tt.png";
import wvs from "./logo/wvs.svg";
import twt from "./logo/x.png";
import qwer from "./logo/qwers.jpeg";
import q from "./logo/q.jpeg";
import w from "./logo/w.jpeg";
import e from "./logo/e.jpeg";
import r from "./logo/r.jpg";
import chz from "./logo/chz.png";

import i18n from "../src/lang/i18n";

/* 플랫폼 메타(아이콘 + 표기명). 링크 데이터는 아래 MEMBERS에서 참조 */
const PLATFORM = {
  youtube: { icon: ytb_2, label: "YouTube" },
  instagram: { icon: Insta, label: "Instagram" },
  naver: { icon: naver, label: "Naver Cafe" },
  weverse: { icon: wvs, label: "Weverse" },
  x: { icon: twt, label: "X" },
  tiktok: { icon: tt, label: "TikTok" },
  twitch: { icon: twitch, label: "Twitch" },
  chzzk: { icon: chz, label: "CHZZK" },
};

/* 기존 페이지의 링크/순서를 그대로 유지한 데이터 구조.
   labelKey가 있으면 다국어 라벨을 사용(예: 아희의 오답노트) */
const MEMBERS = [
  {
    nameKey: "official",
    avatar: qwer,
    links: [
      { type: "youtube", url: "https://www.youtube.com/@QWER_Band_official" },
      { type: "instagram", url: "https://www.instagram.com/qwerband_official/" },
      { type: "naver", url: "https://cafe.naver.com/eggkim" },
      { type: "weverse", url: "https://weverse.io/qwer" },
      { type: "x", url: "https://twitter.com/official_QWER" },
      { type: "tiktok", url: "https://www.tiktok.com/@qwerband_official" },
    ],
  },
  {
    nameKey: "Q",
    avatar: q,
    links: [
      { type: "youtube", url: "https://www.youtube.com/@chodan_" },
      { type: "twitch", url: "https://www.twitch.tv/chodan_" },
      { type: "instagram", url: "https://www.instagram.com/choda._.n" },
      { type: "naver", url: "https://cafe.naver.com/chodancafe" },
      { type: "tiktok", url: "https://www.tiktok.com/@chodan__" },
    ],
  },
  {
    nameKey: "W",
    avatar: w,
    links: [
      { type: "youtube", url: "https://www.youtube.com/@마젠타" },
      {
        type: "youtube",
        url: "https://www.youtube.com/@Aheesoxnote/featured",
        labelKey: "Wnode",
      },
      { type: "twitch", url: "https://www.twitch.tv/magenta62" },
      { type: "x", url: "https://x.com/magentaof62" },
      {
        type: "chzzk",
        url: "https://chzzk.naver.com/c2bb58fbc38e1ce5da52bc1cb9a62cc5",
      },
      { type: "instagram", url: "https://www.instagram.com/magenta_6262" },
      { type: "naver", url: "https://cafe.naver.com/magentacafe" },
      { type: "tiktok", url: "https://www.tiktok.com/@magenta6262" },
    ],
  },
  {
    nameKey: "E",
    avatar: e,
    links: [
      { type: "youtube", url: "https://www.youtube.com/@hapycb" },
      { type: "instagram", url: "https://www.instagram.com/i_am_young22" },
      { type: "x", url: "https://x.com/hapycb" },
      { type: "naver", url: "https://cafe.naver.com/nyangworld" },
      { type: "tiktok", url: "https://www.tiktok.com/@i_am_young22" },
    ],
  },
  {
    nameKey: "R",
    avatar: r,
    links: [
      { type: "instagram", url: "https://www.instagram.com/siyo.co.kr" },
      { type: "tiktok", url: "https://www.tiktok.com/@siyoming___qwer" },
      { type: "x", url: "https://twitter.com/siyo_min" },
    ],
  },
];

const ExternalIcon = () => (
  <svg
    className="snsx-ext"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <path d="M15 3h6v6" />
    <path d="M10 14 21 3" />
  </svg>
);

const SnsPage = ({ darkMode, language, langbt }) => {
  const langs = [
    { code: "ko", label: "KR", onClick: langbt.ko },
    { code: "en", label: "EN", onClick: langbt.en },
    { code: "jp", label: "JP", onClick: langbt.jp },
  ];

  return (
    <div className={`snsx ${darkMode ? "dark-mode" : ""}`}>
      <div className="snsx-panel">
        <h1 className="snsx-title">{language("SNS")}</h1>

        <div className="snsx-lang">
          {langs.map(({ code, label, onClick }) => (
            <button
              key={code}
              type="button"
              className={`snsx-lang-btn ${
                i18n.language === code ? "active" : ""
              }`}
              onClick={onClick}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="snsx-list">
          {MEMBERS.map((member) => (
            <section className="snsx-row" key={member.nameKey}>
              <div className="snsx-profile">
                <div className="snsx-avatar">
                  <img src={member.avatar} alt="" />
                </div>
                <div className="snsx-name">{language(member.nameKey)}</div>
              </div>

              <div className="snsx-links">
                {member.links.map((link) => {
                  const meta = PLATFORM[link.type];
                  const label = link.labelKey
                    ? language(link.labelKey)
                    : meta.label;
                  return (
                    <a
                      className="snsx-link"
                      key={link.url}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="snsx-link-icon">
                        <img src={meta.icon} alt="" />
                      </span>
                      <span className="snsx-link-label">{label}</span>
                      <ExternalIcon />
                    </a>
                  );
                })}
              </div>
            </section>
          ))}
        </div>
      </div>

      <footer className="footer snsx-footer">{language("footer")}</footer>
    </div>
  );
};

export default SnsPage;
